import { render, staticRenderFns } from "./teamHonor.vue?vue&type=template&id=4589641a&scoped=true"
import script from "./teamHonor.vue?vue&type=script&lang=js"
export * from "./teamHonor.vue?vue&type=script&lang=js"
import style0 from "./teamHonor.vue?vue&type=style&index=0&id=4589641a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4589641a",
  null
  
)

export default component.exports